import { capitalCase } from 'change-case';

export function buildSafeIdForSection(name: string): string {
  return name.replace(/[ ()]/g, '');
}

const caseOverrides = {
  Aml: 'AML',
  Api: 'API',
  Cip: 'CIP',
  Mfa: 'MFA',
  Otp: 'OTP',
  Sdn: 'SDN',
  Ofac: 'OFAC',
  Ach: 'ACH',
  Html: 'HTML',
  Pdf: 'PDF',
  Jpmam: 'JPMAM',
  Lpm: 'LPM',
  Finra: 'FINRA',
  Taf: 'TAF',
  Sec: 'SEC',
  Kyc: 'KYC',
  Eod: 'EOD',
} as const;

export function applyDisplayNameCase(serviceName: string): string {
  const sentenceCased = capitalCase(serviceName);

  return sentenceCased
    .split(' ')
    .map((word) => caseOverrides[word as keyof typeof caseOverrides] || word)
    .join(' ');
}

export function buildPathForDocsItem(path: string, hash?: string): string {
  const url = new URL(path, window.location.origin);
  if (hash) {
    url.hash = hash;
  }

  url.search = window.location.search;

  return url.toString().replace(window.location.origin, '');
}
